<ng-scrollbar #scrollable pointerEventsMethod="scrollbar" [disabled]="disabled">
        
    <h2 class="header-container" mat-dialog-title>Meeting Dialog</h2>
    <mat-dialog-content class="main-container">
        <div class="content-container">
            <div class="sub-header-container">
                <div class="left-sub-header-container">
                    <h3>
                        {{currentDateTwo}} at 2:00 PM for 60 Minutes
                    </h3>
                </div>
            </div>
            <div>
                <ul class="un-order-list-container">
                    <li class = "list-item">
                        Lakshmi Kala M
                    </li>
                    <li class = "list-item">
                        ShivaKumar M
                    </li>
                    <li class = "list-item">
                        Chandrasekar K
                    </li>
                    <li class = "list-item">
                        3 More ...
                    </li>
                </ul>
            </div>
            <div>
                <mat-list>
                        <mat-divider></mat-divider>
                        <mat-list-item class="list">
                            <div class="list-item-container">
                                <div>
                                    <div>
                                        <h3>Agenda - 1 : </h3>
                                    </div>
                                </div>
                                <div>
                                    <h3>Project Status Meeting</h3>
                                    <h4>Status : Approved</h4>
                                </div>
                            </div>
                            <!-- <div class="agenda-description">
                                <div class="sub-agenda-description">
                                    <div>
                                        <h3>Note</h3>
                                    </div>
                                    <div>
                                        <h4>Notes</h4>
                                    </div>
                                </div>
                                <div class="sub-agenda-description">
                                    <div>
                                        <h3>Task</h3>
                                    </div>
                                    <div>
                                        <h4>Tasks</h4>
                                    </div>
                                </div>
                            </div> -->
                        </mat-list-item>
                        <mat-divider></mat-divider>
                        <mat-list-item class="list">
                            <div class="list-item-container">
                                <div>
                                    <div>
                                        <h3>Agenda - 1 : </h3>
                                    </div>
                                </div>
                                <div>
                                    <h3>Project Status Meeting</h3>
                                    <h4>Status : Approved</h4>
                                </div>
                            </div>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                        <mat-list-item class="list">
                            <div class="list-item-container">
                                <div>
                                    <div>
                                        <h3>Agenda - 1 : </h3>
                                    </div>
                                </div>
                                <div>
                                    <h3>Project Status Meeting</h3>
                                    <h4>Status : Approved</h4>
                                </div>
                            </div>
                        </mat-list-item>
                        <mat-divider></mat-divider>
                        <mat-list-item class="list">
                            <div class="list-item-container">
                                <div>
                                    <div>
                                        <h3>Agenda - 1 : </h3>
                                    </div>
                                </div>
                                <div>
                                    <h3>Project Status Meeting</h3>
                                    <h4>Status : Approved</h4>
                                </div>
                            </div>
                        </mat-list-item>
                </mat-list>
            </div>
        </div>
    </mat-dialog-content>
</ng-scrollbar>